import React from "react";
import { Link } from "react-router-dom";

const LinkToTopPageBtn = () => {
  const design_box_bottom_bottom = {
    marginTop: "80px",
    alignSelf: "center",
    marginBottom: "50px",
  };

  const design_box_bottom_bottom_button = {
    width: "200px",
    height: "40px",
    backgroundColor: "white",
    borderRadius: "35px",
    border: "1px solid #70707066",
    fontSize: "13px",
    letterSpacing: "0.65px",
    color: "#000000c7",
    fontFamily: '"Noto Sans JP", sans-serif',
    fontWeight: 500,
    paddingBottom: "2px",
    cursor: "pointer",
  };

  return (
    <div style={design_box_bottom_bottom}>
      <Link to={"/top"}>
        <button style={design_box_bottom_bottom_button}>マイページ</button>
      </Link>
    </div>
  );
};

export default LinkToTopPageBtn;
